"use client";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body style={{ fontFamily: "system-ui, sans-serif", padding: "2rem" }}>
        <h1 style={{ color: "#dc2626" }}>Erreur DoliUI</h1>
        <div
          style={{
            background: "#fef2f2",
            border: "1px solid #fecaca",
            borderRadius: "8px",
            padding: "1rem",
            marginTop: "1rem",
          }}
        >
          <p style={{ fontFamily: "monospace", color: "#b91c1c" }}>
            {error.message}
          </p>
          {process.env.NODE_ENV === "development" && error.stack && (
            <pre
              style={{
                fontSize: "12px",
                color: "#991b1b",
                overflow: "auto",
                maxHeight: "200px",
                marginTop: "0.5rem",
              }}
            >
              {error.stack}
            </pre>
          )}
        </div>
        <button
          onClick={reset}
          style={{
            marginTop: "1rem",
            padding: "0.5rem 1rem",
            background: "#2563eb",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Réessayer
        </button>
      </body>
    </html>
  );
}
